import React from "react"
import { graphql } from "gatsby"

import { CONSTANTS } from "@data"
import { logTool } from "@jsUtils"

import { Meta, ContentRow, ContentItem, ContentCopy, GridLines } from "@shared"
import { Footer, Header, HeroGrid, Banner } from "@components/sections"

import Styles from "./legal.module.scss"

const { PAGE_NAMES, THEMES, COLORS } = CONSTANTS

const log = logTool()

/**
 * Page Template
 * Render a Legal page with this template
 * @param {object} props - react props
 */
const LegalPage = props => {
  const { data } = props
  const { contentfulLegalPage, contentfulPageMeta } = data
  const { bottomBanner } = contentfulLegalPage

  log("Legal Page content:", { contentfulLegalPage, contentfulPageMeta })

  return (
    <>
      <Meta base={contentfulPageMeta} page={contentfulLegalPage} />
      <Header theme={THEMES.LIGHT} pageColor={COLORS.LIGHT} />
      <HeroGrid
        shortHeroSection
        theme={THEMES.LIGHT}
        color={COLORS.FLURO}
        page={PAGE_NAMES.LEGAL}
        content={contentfulLegalPage}
        classes={{
          extraHeroSection: Styles.legalWrapper,
          extraHeroWrapperRow: Styles.headerWrapper,
          extraPageHeadingContent: Styles.pageHeadingContent
        }}
      />
      <ContentRow extraClass={Styles.contentBlock}>
        <GridLines theme={THEMES.LIGHT} />
        <ContentItem gridArea="article">
          <ContentCopy data={contentfulLegalPage} />
        </ContentItem>
      </ContentRow>
      <Banner data={bottomBanner} />
      <Footer />
    </>
  )
}

/**
 * pageQuery for Legal Page
 */
export const pageQuery = graphql`
  query($slug: String!) {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    contentfulLegalPage(slug: { eq: $slug }) {
      pageMeta {
        ...PageMetaData
      }
      id
      title
      content {
        childMarkdownRemark {
          html
        }
      }
      contentMore {
        childMarkdownRemark {
          html
        }
      }
      bottomBanner {
        ...BannerSection
      }
    }
  }
`

export default LegalPage
